import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent implements OnInit {

  constructor() {

  }

  ngOnInit() {
  }

  getBackgroundImageStyle(i) {
    return {
      'background-image': 'url(/assets/images/services/' + i + '.jpg)',
    };
  }

}

